// extracted by mini-css-extract-plugin
export default {"balk":"DevBalk_balk__TMhpS"};